<template lang="pug">
  el-header.LessonHeader
    v-layout(row)
      v-flex(xs3)
          ButtonReturn(@prev="$emit('prev')" :onlyFather="onlyFather")
      v-flex.text-xs-center(xs6)
          BreadCrumb
      v-flex(xs3)
</template>
<script>
import ButtonReturn from '@/components/button-return/button-return2'
import BreadCrumb from '@/components/breadcrumb/breadcrumb'
export default {
  name: 'LessonHeader',
  components:{
      ButtonReturn,
      BreadCrumb
  },
  props: {        
    onlyFather: {
      type: Boolean,
      default: false
    }    
  }
}
</script>

<style scoped>
@import 'lesson-header.scss';
</style>

